// MobileFileUpload.js
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

const Transition = props => <Slide direction="up" {...props} />;

// -------- Styled Components --------
const Sheet = styled.div`
  padding: 16px;
  background: white;
`;

const OptionButton = styled(Button)`
  && {
    width: 100%;
    margin-top: 12px;
    text-transform: none;
  }
`;

const HiddenInput = styled.input`
  display: none;
`;

export default function MobileFileUpload({ onFileSelected, onCustomCamera, accept = 'image/*', children }) {
  const [open, setOpen] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleNativePick = () => {
    setOpen(false);
    requestAnimationFrame(() => {
      fileInputRef.current?.click();
    });
  };

  const handleNativeChange = e => {
    e.preventDefault();
    const file = e.target.files?.[0];
    if (file && onFileSelected) onFileSelected(file);
  };

  const handleCustomCamera = () => {
    setOpen(false);
    onCustomCamera?.();
  };

  return (
    <>
      {/* Trigger element */}
      <div onClick={() => setOpen(true)} style={{ display: 'inline-block' }}>
        {children}
      </div>

      {/* Hidden native file input */}
      <HiddenInput type="file" accept={accept} ref={fileInputRef} onChange={handleNativeChange} />

      {/* Bottom Sheet */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        TransitionComponent={Transition}
        fullWidth
        PaperProps={{
          style: { margin: 0, bottom: 0, position: 'absolute' }
        }}
      >
        <Sheet>
          <OptionButton variant="contained" color="primary" onClick={handleCustomCamera}>
            Use camera
          </OptionButton>

          <OptionButton variant="outlined" color="primary" onClick={handleNativePick}>
            Choose from device
          </OptionButton>

          <OptionButton variant="contained" onClick={() => setOpen(false)} color="secondary">
            Cancel
          </OptionButton>
        </Sheet>
      </Dialog>
    </>
  );
}
